<template>
  <div>
    <h4>Diagnostics de performance énergétique</h4>
    <div class="dpe-container">
      <div v-if="!bien.d_dpeClasseCEP || bien.d_dpeClasseCEP === ''" class="na">
      </div>
      <div v-else class="bg-conso" :class="'bg-dpe-' + bien.d_dpeClasseCEP">
        <div class="valDPE" :class="bien.d_dpeClasseCEP">
          {{ bien.d_dpeConsommation }}
        </div>
      </div>
      <div v-if="bien.d_dpeClasseCEP || bien.d_dpeClasseCEP !== ''" class="bg-ges"
        :class="'bg-ges-' + bien.d_dpeClasseGES">
        <div class="valGES" :class="bien.d_dpeClasseGES">
          {{ bien.d_dpeEmmissionGES }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DPE',
  props: {
    bien: Object
  }
}
</script>

<style lang="scss">
.dpe-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 24px 0;
}

.A {
  bottom: 11.4rem;
}

.B {
  bottom: 9.5rem;
}

.C {
  bottom: 7.7rem;
}

.D {
  bottom: 5.8rem;
}

.E {
  bottom: 4rem;
}

.F {
  bottom: 2.1rem;
}

.G {
  bottom: 0.5rem;
}

.na {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette energie A.svg');
  filter: grayscale(100%) !important;
  background-size: contain;
  height: 220px;
  width: 371px;
  position: relative;
  background-repeat: no-repeat;
}

.na::after {
  display: block;
  content: 'non applicable';
  top: 48%;
  position: absolute;
  left: 20%;
  font-size: 1.5rem;
  font-weight: 800;
  color: gray;
}

.bg-conso {
  background-size: contain;
  height: 220px;
  width: 371px;
  position: relative;
  background-repeat: no-repeat;

  .valDPE {
    color: black;
    left: 1.2rem;
    font-weight: bold;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1.5rem;
    line-height: 1;
  }

  .valDPE::after {
    font-weight: normal;
    font-size: 0.8rem;
    content: 'kWh/m²/an';
  }
}

.bg-ges {
  background-size: contain;
  height: 220px;
  width: 320px;
  position: relative;
  background-repeat: no-repeat;

  .valGES {
    color: black;
    left: 13rem;
    font-weight: bold;
    position: absolute;
    font-size: 1.5rem;
    line-height: 1;
  }

  .valGES::after {
    font-weight: normal;
    font-size: 0.8rem;
    content: 'kg CO2/m²/an';
  }
}

.bg-dpe-A {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette energie A.svg');
}

.bg-dpe-B {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette energie B.svg');
}

.bg-dpe-C {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette energie C.svg');
}

.bg-dpe-D {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette energie D.svg');
}

.bg-dpe-E {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette energie E.svg');
}

.bg-dpe-F {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette energie F.svg');
}

.bg-dpe-G {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette energie G.svg');
}

.bg-ges-A {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette GES A.svg');
}

.bg-ges-B {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette GES B.svg');
}

.bg-ges-C {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette GES C.svg');
}

.bg-ges-D {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette GES D.svg');
}

.bg-ges-E {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette GES E.svg');
}

.bg-ges-F {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette GES F.svg');
}

.bg-ges-G {
  background-image: url('../assets/images/dpeBackground/DPE__etiquette GES G.svg');
}
</style>
